interface GroupTitleProps {
    children: React.ReactNode;
}

const GroupTitle = ({ children }: GroupTitleProps) => (
    <div className="text-xl font-bold capitalize">{children}</div>
);

export default GroupTitle;
